import { KYMW9005Model } from '../kymw9005.model'; 
import { KYMW9005InputModel } from '../vo/kymw9005-input.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 関連会社ユーザ情報を取得する。
 *
 * @export API通信成功時の処理
 * @class GetAssociatedUserManagementDetailService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetAssociatedUserManagementDetailService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9005Model;
  private successFunc: Function;
  private vo: KYMW9005InputModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetAssociatedUserManagementDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        AssociatedUserId: this.vo.associatedUserId,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetAssociatedUserManagementDetailService
   */
  execute(model: KYMW9005Model, vo: KYMW9005InputModel, successFunc: Function = null):void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getAssociatedUserManagementDetail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAssociatedUserManagementDetailService
   */
  success(data: any):void {
    if ( data !== null ) {
      this.model.updateUserInformationDeatil(data);
    } else {
      this.dialogService.openAlert('システムエラーが発生しました', 'S')
    }
    
  }
}